import { PersonalMovie } from '../services/personalMoviesService';

export const isValidPersonalMovie = (movie: any): movie is PersonalMovie => {
  if (!movie || typeof movie !== 'object' || movie === null) {
    return false;
  }

  if (!movie.id || (typeof movie.id !== 'string' && typeof movie.id !== 'number')) {
    return false;
  }

  if (!movie.user_id || typeof movie.user_id !== 'string') {
    return false;
  }

  if (!movie.title || typeof movie.title !== 'string') {
    return false;
  }

  if (!movie.color || typeof movie.color !== 'string') {
    return false;
  }

  if (!movie.emoji || typeof movie.emoji !== 'string') {
    return false;
  }

  return true;
};

export const sanitizePersonalMovie = (movie: any): PersonalMovie | null => {
  if (!isValidPersonalMovie(movie)) {
    console.warn('Movie validation failed for:', movie);
    console.warn('Validation checks:');
    console.warn('- Is object:', movie && typeof movie === 'object' && movie !== null);
    console.warn('- Has valid id:', movie?.id && (typeof movie.id === 'string' || typeof movie.id === 'number'));
    console.warn('- Has valid user_id:', movie?.user_id && typeof movie.user_id === 'string');
    console.warn('- Has valid title:', movie?.title && typeof movie.title === 'string');
    console.warn('- Has valid color:', movie?.color && typeof movie.color === 'string');
    console.warn('- Has valid emoji:', movie?.emoji && typeof movie.emoji === 'string');
    return null;
  }

  try {
    return {
      id: String(movie.id),
      user_id: movie.user_id,
      title: movie.title ? movie.title.trim() : 'Untitled Movie',
      color: movie.color || '#3b82f6',
      emoji: movie.emoji || '🎬',
      created_at: movie.created_at || new Date().toISOString(),
      updated_at: movie.updated_at || new Date().toISOString()
    };
  } catch (error) {
    console.warn('Error sanitizing movie data:', error, movie);
    return null;
  }
};

export const sanitizePersonalMovies = (movies: any[]): PersonalMovie[] => {
  if (!Array.isArray(movies)) {
    return [];
  }

  return movies
    .map(sanitizePersonalMovie)
    .filter((movie): movie is PersonalMovie => movie !== null);
};